import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '../../../../utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';

interface IObtainedFundsBeforeProps {
    baseline: any[];
}

const ObtainedFundsBefore = ({baseline}: IObtainedFundsBeforeProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const success = baseline.filter((submission: any) => submission.question10 === 'item1').length;
        const unSuccess = baseline.filter((submission: any) => submission.question10 === 'item3').length;
        const pending = baseline.filter((submission: any) => submission.question10 === 'item2').length;

        const title = '% of entrepreneurs who obtained funds before the acceleration program';
        const data = [
            {
                name: 'Yes',
                y: success,
                color: COLORS.blue,
            },
            {
                name: 'No',
                y: unSuccess,
                color: COLORS.yellow,
            },
            {
                name: 'Pending',
                y: pending,
                color: COLORS.gray,
            },
        ];

        const dashboardOptions: any = getDefaultPieFormatting(
            title,
            data,
            1,
            {},
        );
        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default ObtainedFundsBefore;
